import React from 'react';
import { SendDialog } from 'components';
import useSafe from 'hooks/use-safe';
import { useSendStxDialog } from 'store';

export const SendAssetDialog = () => {
  const { safe, assetList } = useSafe();
  const { isSendStxDialogOpen, setSendStxDialogOpen, selectedTokenIndex } = useSendStxDialog();

  return (
    <>
      {isSendStxDialogOpen && (
        <SendDialog
          open={isSendStxDialogOpen}
          tokenList={assetList}
          safeAddress={safe.address}
          selectedTokenIndex={selectedTokenIndex}
          onClose={() => setSendStxDialogOpen(false)}
          onContinue={(successful, message) => {
            // setTransactionMessagePopupShown(true);
            // setTransactionResultStatus(
            //   successful ? TransactionResultStatus.success : TransactionResultStatus.rejected
            // );
            // setTransactionResultMessage(message);
          }}
        />
      )}
    </>
  );
};
